<p-dialog
  [header]="texts.HEADER"
  [modal]="true"
  [(visible)]="visible"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '64rem', maxWidth: '95vw' }"
  styleClass="duplicated-combination-dialog"
  (onHide)="close()">

  <div class="dc">

    <div class="dc__notice" role="alert">
      <i class="pi pi-exclamation-triangle dc__notice-icon" aria-hidden="true"></i>
      <p class="dc__lead">{{ texts.LEAD }}</p>
      <span class="dc__count">{{ projects.length }}</span>
    </div>

    <dl class="dc__combo">
      <div class="dc__combo-item">
        <dt>Formulation</dt>
        <dd>{{ formulationName || '—' }}</dd>
      </div>
      <div class="dc__combo-item">
        <dt>Geography</dt>
        <dd>{{ geographyName || '—' }}</dd>
      </div>
    </dl>

    <p-table
      [value]="projects"
      [scrollable]="true"
      scrollHeight="18rem"
      [rowHover]="true"
      styleClass="p-datatable-sm p-datatable-striped dc__table">
      <ng-template pTemplate="header">
        <tr>
          <th class="dc__col-project">{{ texts.COLUMN_PROJECT }}</th>
          <th class="dc__col-created-by">{{ texts.COLUMN_CREATED_BY }}</th>
          <th class="dc__col-date">{{ texts.COLUMN_CREATED_DATE }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-project>
        <tr>
          <td class="dc__col-project">
            <div class="dc__project">
              <span class="dc__name" [title]="project.name">{{ project.name }}</span>
              <button type="button"
                class="dc__pk"
                [title]="texts.OPEN_PROJECT_TOOLTIP"
                [attr.aria-label]="texts.OPEN_PROJECT_ARIA + ' ' + project.projectPk"
                (click)="selectProject(project.projectPk)">
                #{{ project.projectPk }}
                <i class="pi pi-external-link" aria-hidden="true"></i>
              </button>
            </div>
          </td>
          <td class="dc__col-created-by">{{ project.createdBy }}</td>
          <td class="dc__col-date">{{ project.createdDate | date: 'dd-MMM-yyyy' }}</td>
        </tr>
      </ng-template>
    </p-table>

    <div class="dc__hint">
      <i class="pi pi-info-circle" aria-hidden="true"></i>
      <span>{{ texts.HINT }}</span>
    </div>

  </div>

  <ng-template pTemplate="footer">
    <app-button
      [label]="texts.CLOSE_BUTTON"
      [size]="'small'"
      (onClickEvent)="close()"></app-button>
  </ng-template>

</p-dialog>
